export const img = (id, w = 1600) => {
  if (!id || typeof id !== "string") return "/assets/logo.png";
  return id.startsWith("/") || id.startsWith("http")
    ? id
    : `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;
};

// Client-supplied photography + brand logo
export const ASSETS = {
  stoneFloorRoom: "/assets/a1.jpg",
  stonePavers: "/assets/a2.jpg",
  veneerShelves: "/assets/a3.jpg",
  slatWall: "/assets/a4.jpg",
  logoDark: "/assets/logo-dark.png",
  logoLight: "/assets/logo-light.png",
};

export const BYLINE = "Purveyors of Fine Interiors";

export const CONTACT = {
  city: "Auckland, New Zealand",
  address: ["28 Constellation Drive", "Auckland"],
  email: "info@hod.co.nz",
  phone: "021 430 559",
  hours: [
    { day: "Monday – Friday", time: "8:30am – 5:00pm" },
    { day: "Saturday", time: "10:00am – 4:00pm" },
    { day: "Sunday", time: "By appointment" },
  ],
  socials: [
    { label: "Facebook", href: "https://www.facebook.com/HouseofdavidNZ/" },
  ],
};

export const IMG = {
  hero: "photo-1729837149090-764b4272c2d7",
  timberGeo: "photo-1760237655540-8197ef24838b",
  beamsShadow: "photo-1763269546708-a3590bc5441f",
  curvedBeams: "photo-1769721143812-3cb8ae1ca8ed",
  woodBoard1: "photo-1611600700192-d87eaeed4f81",
  woodBoard2: "photo-1621295693450-080546d2ec8e",
  woodBoard3: "photo-1583418007992-a8e33a92e7ad",
  woodBoard4: "photo-1525947088131-b701cd0f6dc3",
  sofa: "photo-1567016376408-0226e4d0c1ea",
  living1: "photo-1637412816281-f80ec9948fea",
  living2: "photo-1628744876497-eb30460be9f6",
  living3: "photo-1724582586529-62622e50c0b3",
  kitchen: "photo-1663811396777-05505d999151",
  herring1: "photo-1778804796478-f669c5f79492",
  herring2: "photo-1761053130711-2515ef532bb5",
  parquet: "photo-1761053133165-0f3acdaf1770",
  herring3: "photo-1770982726897-5e85ad0601c3",
  sawing: "photo-1547609434-b732edfee020",
  cutting: "photo-1659930087003-2d64e33181f7",
  chairwork: "photo-1631396326646-c06a935ff3a6",
  frame: "photo-1627170323706-4504ead44eb8",
  spiral: "photo-1584247793672-567c535a5e44",
  concreteWood: "photo-1614595737476-42487331b8a1",
  whiteConcrete: "photo-1549791084-5f78368b208b",
  stair1: "photo-1591638212063-c2f69701a931",
  stair4: "photo-1580911498851-4999ad5327b6",
  sketch: "photo-1542621334-a254cf47733d",
  consult: "photo-1730342754687-956c90fb0db9",
  catalogue: "photo-1655457397686-4dd23e78a918",
  midHero: "photo-1769721143812-3cb8ae1ca8ed",
  carpetAxminster: "photo-1616980540826-5542d5aad277",
  carpetTiles: "photo-1671624760664-8946fd3037a3",
  broadloom: "photo-1545078194-2ec3c4e53ed1",
  rug: "https://images.pexels.com/photos/19203526/pexels-photo-19203526.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  microcement: "https://images.pexels.com/photos/2768390/pexels-photo-2768390.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  oakDoor: "photo-1752407828526-0e01a9f2e13c",
};

export const LOREM = {
  short:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur vitae nunc sed velit dignissim sodales ut eu sem.",
  medium:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.",
  long:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
};

export const NAV = [
  {
    label: "Our Collection",
    to: "/collection",
    id: "collection",
    children: [
      { label: "Timber Collection", to: "/collections/timber" },
      { label: "Architectural Stone Collection", to: "/collections/natural-stone" },
      { label: "Custom Carpet Collection", to: "/collections/custom-carpet" },
      { label: "Wall Panel Collection", to: "/collections/hod-wall-panels" },
    ],
  },
  { label: "Our Portfolio", to: "/portfolio", id: "portfolio" },
  { label: "Services", to: "/services", id: "services" },
  { label: "Our Story", to: "/story", id: "story" },
];

export const ENQUIRE = { label: "Enquire", to: "/contact" };

export const CATEGORIES = {
  timber: {
    slug: "timber",
    name: "Timber Collection",
    index: "01",
    tagline: "Veneers, Panels & Solid Woods",
    banner: ASSETS.veneerShelves,
    intro:
      "From wide-plank oak flooring to architectural veneers and slatted wall panels, our timber collection brings warmth, texture and lasting character to any interior. Every piece is hand-selected, ready to sample.",
    gallery: [
      { src: ASSETS.veneerShelves, title: "Veneer Panels" },
      { src: IMG.woodBoard1, title: "European Oak" },
      { src: IMG.woodBoard2, title: "Smoked Walnut" },
      { src: IMG.beamsShadow, title: "Blackened Ash" },
      { src: IMG.woodBoard4, title: "Reclaimed Elm" },
      { src: IMG.woodBoard3, title: "Char Larch" },
    ],
    specs: [
      { label: "Origin", value: "Responsibly sourced European forests" },
      { label: "Grades", value: "Prime · Natural · Rustic" },
      { label: "Finishes", value: "Oiled · Brushed · Fumed · Raw" },
      { label: "Supply", value: "Boards · Panels · Veneers to order" },
    ],
  },
  interior: {
    slug: "interior",
    name: "Interior",
    index: "02",
    tagline: "Surfaces, Slats & Finishes",
    banner: ASSETS.slatWall,
    intro:
      "The tactile materials designers reach for — timber, stone and panel systems ready to specify. We supply the surfaces and finishes that give a room its atmosphere, curated for New Zealand's most considered interiors.",
    gallery: [
      { src: ASSETS.slatWall, title: "Slat Feature Walls" },
      { src: IMG.living1, title: "Living Compositions" },
      { src: IMG.kitchen, title: "Culinary Spaces" },
      { src: IMG.living2, title: "Quiet Rooms" },
      { src: IMG.frame, title: "Joinery Detail" },
      { src: IMG.spiral, title: "Sculptural Forms" },
    ],
    specs: [
      { label: "Range", value: "Curated interior surfaces & finishes" },
      { label: "Materials", value: "Timber · Stone · Veneer · Panels" },
      { label: "Service", value: "Supplied to trade & private clients" },
      { label: "Availability", value: "Ex-stock & indent to order" },
    ],
  },
  flooring: {
    slug: "flooring",
    name: "Flooring",
    index: "03",
    tagline: "Planks, Parquet & Stone",
    banner: ASSETS.stoneFloorRoom,
    intro:
      "Engineered timber, parquet and natural stone flooring — supplied plank by plank and tile by tile. Durable, beautiful and delivered nationwide to your builder or fitter, in the pattern and finish your project demands.",
    gallery: [
      { src: ASSETS.stoneFloorRoom, title: "Stone Tile" },
      { src: ASSETS.stonePavers, title: "Cut Pavers" },
      { src: IMG.herring1, title: "Herringbone" },
      { src: IMG.parquet, title: "Chevron" },
      { src: IMG.herring2, title: "Wide Plank" },
      { src: IMG.herring3, title: "Basketweave" },
    ],
    specs: [
      { label: "Construction", value: "Engineered multi-ply core & natural stone" },
      { label: "Patterns", value: "Herringbone · Chevron · Plank · Modular" },
      { label: "Wear layer", value: "3–6mm real timber lamella" },
      { label: "Supply", value: "Delivered nationwide to your fitter" },
    ],
  },
};

export const PROJECTS = [
  {
    slug: "shoreline-residence",
    title: "Shoreline Residence",
    category: "Residential",
    year: "2025",
    cover: IMG.living2,
    gallery: [IMG.kitchen, IMG.living1, IMG.herring2, IMG.curvedBeams],
  },
  {
    slug: "atelier-house",
    title: "Atelier House",
    category: "Interior",
    year: "2024",
    cover: IMG.concreteWood,
    gallery: [IMG.frame, IMG.living3, IMG.spiral, IMG.woodBoard2],
  },
  {
    slug: "vinter-pavilion",
    title: "Vinter Pavilion",
    category: "Architecture",
    year: "2024",
    cover: IMG.whiteConcrete,
    gallery: [IMG.beamsShadow, IMG.curvedBeams, IMG.stair4, IMG.woodBoard1],
  },
  {
    slug: "nordlys-loft",
    title: "Nordlys Loft",
    category: "Flooring",
    year: "2023",
    cover: IMG.herring1,
    gallery: [IMG.parquet, IMG.herring3, IMG.stair1, IMG.living1],
  },
  {
    slug: "grove-studio",
    title: "Grove Studio",
    category: "Timber",
    year: "2023",
    cover: IMG.beamsShadow,
    gallery: [IMG.timberGeo, IMG.woodBoard4, IMG.sawing, IMG.cutting],
  },
  {
    slug: "kattegat-villa",
    title: "Kattegat Villa",
    category: "Residential",
    year: "2022",
    cover: IMG.living3,
    gallery: [IMG.kitchen, IMG.sofa, IMG.stair4, IMG.herring2],
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Material First",
    body: "We lead with the material. Every board, panel and tile is chosen for its grain, tone and integrity long before anything else.",
  },
  {
    no: "02",
    title: "Responsibly Sourced",
    body: "Our timber and stone are drawn from managed forests and quarries, from suppliers who share our respect for the land.",
  },
  {
    no: "03",
    title: "Built to Endure",
    body: "We favour finishes that age gracefully — fine interiors should look better in twenty years, not tired.",
  },
  {
    no: "04",
    title: "Considered Service",
    body: "From first sample to final delivery, we make specification effortless for designers and trade alike.",
  },
];

export const slugify = (s) =>
  s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

const mk = (name, sub, image, extra = {}) => ({
  slug: slugify(name),
  name,
  sub,
  image,
  ...extra,
});

const POOL = {
  wood: [ASSETS.slatWall, IMG.beamsShadow, IMG.woodBoard1, IMG.woodBoard2, IMG.woodBoard3, IMG.woodBoard4, ASSETS.veneerShelves, IMG.herring1, IMG.parquet, IMG.herring2, IMG.herring3, IMG.curvedBeams],
  stone: [ASSETS.stoneFloorRoom, ASSETS.stonePavers, IMG.whiteConcrete, IMG.microcement, IMG.frame, IMG.concreteWood],
  carpet: [IMG.carpetAxminster, IMG.carpetTiles, IMG.broadloom, IMG.rug],
};

const expand = (curated, target, prefixes, subs, images) => {
  const out = [...curated];
  let i = out.length;
  while (out.length < target) {
    const name = `${prefixes[i % prefixes.length]} ${String(i + 1).padStart(2, "0")}`;
    out.push(mk(name, subs[i % subs.length], images[i % images.length]));
    i++;
  }
  return out;
};

export const COLLECTIONS = {
  timber: {
    slug: "timber",
    index: "01",
    name: "Timber Collection",
    tagline: "Wall Panels · Veneers · Flooring",
    banner: ASSETS.slatWall,
    homeImage: "/assets/home/timber.png",
    intro:
      "Warm, tactile and enduring — our timber collection spans architectural wall panels, fine veneers and engineered flooring, each hand-selected for New Zealand's most considered interiors.",
    brochure: { url: "/assets/brochures/timber-panels.pdf", name: "Timber Panels Brochure 2026" },
    subcategories: ["Wall Panels", "Veneers", "Flooring"],
    products: [
      mk("Unfinished Oak Acoustic Slat Panel", "Wall Panels", ASSETS.slatWall),
      mk("Grey Oak Acoustic Slat Panel", "Wall Panels", IMG.beamsShadow),
      mk("Smoked Oak Slat Panel", "Wall Panels", IMG.woodBoard2),
      mk("Charred Larch Slat Panel", "Wall Panels", IMG.woodBoard3),
      mk("Radica di Madrona Veneer", "Veneers", ASSETS.veneerShelves),
      mk("Milk Oak Veneer Panel", "Veneers", IMG.woodBoard1),
      mk("Blackened Ash Veneer", "Veneers", IMG.woodBoard4),
      mk("Herringbone Oak Flooring", "Flooring", IMG.herring1),
      mk("Chevron Oak Flooring", "Flooring", IMG.parquet),
      mk("Wide Plank Oak Flooring", "Flooring", IMG.herring2),
    ],
  },
  "natural-stone": {
    slug: "natural-stone",
    index: "02",
    name: "Architectural Stone Collection",
    tagline: "Marble · Limestone · Slate",
    banner: ASSETS.stonePavers,
    homeImage: "/assets/home/stone.webp",
    heroSlides: [
      "/assets/home/landing-hero.jpg",
      "/assets/stone-hero/s2.png",
      "/assets/stone-hero/s3.webp",
    ],
    heroFit: "cover",
    intro:
      "A curated range of natural stone — chosen for depth of colour and honest texture. All can be made to order, custom.",
    brochure: { url: "/assets/brochures/natural-stone.pdf", name: "Architectural Stone Brochure 2026" },
    subcategories: ["Limestone", "Marble", "Slate", "Black Marble"],
    products: [
      mk("Sand Limestone", "Limestone", "/assets/stone/1.png"),
      mk("Travertine Limestone", "Limestone", "/assets/stone/2.png"),
      mk("Classic Limestone", "Limestone", "/assets/stone/3.png"),
      mk("Antique Limestone", "Limestone", "/assets/stone/4.png"),
      mk("Tumbled Limestone", "Limestone", "/assets/stone/5.png"),
      mk("Carrara Marble", "Marble", "/assets/stone/6.png"),
      mk("Statuario Marble", "Marble", "/assets/stone/7.png"),
      mk("Bianco Marble", "Marble", "/assets/stone/8.png"),
      mk("Pearl Marble", "Marble", "/assets/stone/9.png"),
      mk("Silver Slate", "Slate", "/assets/stone/10.png"),
      mk("Rustic Slate", "Slate", "/assets/stone/11.png"),
      mk("Riven Slate", "Slate", "/assets/stone/12.png"),
      mk("Nero Black Marble", "Black Marble", "/assets/stone/13.png"),
      mk("Noir Black Marble", "Black Marble", "/assets/stone/14.png"),
      mk("Charcoal Black Marble", "Black Marble", "/assets/stone/15.png"),
    ],
  },
  "custom-carpet": {
    slug: "custom-carpet",
    index: "03",
    name: "Custom Carpet Collection",
    tagline: "Bespoke Woven Carpet",
    banner: "/assets/custom-carpet/k2987-installed.jpg",
    homeImage: "/assets/home/carpet.png",
    heroSlides: [
      "/assets/custom-carpet/k2987-installed.jpg",
      "/assets/custom-carpet/k3009-installed.jpg",
      "/assets/custom-carpet/k3090-installed.jpg",
    ],
    intro:
      "Bespoke soft flooring, made to order. Each design is woven to your palette and space — shown here as a flat sample and installed in a real interior.",
    brochure: { url: "/assets/brochures/custom-carpet.pdf", name: "Custom Carpet Collection Brochure 2026" },
    subcategories: ["Custom Carpet"],
    products: [
      mk("K2987", "Custom Carpet", "/assets/custom-carpet/k2987-tile.jpg", { installed: "/assets/custom-carpet/k2987-installed.jpg" }),
      mk("K2995", "Custom Carpet", "/assets/custom-carpet/k2995-tile.jpg", { installed: "/assets/custom-carpet/k2995-installed.jpg" }),
      mk("K3007", "Custom Carpet", "/assets/custom-carpet/k3007-tile.jpg", { installed: "/assets/custom-carpet/k3007-installed.jpg" }),
      mk("K3009", "Custom Carpet", "/assets/custom-carpet/k3009-tile.jpg", { installed: "/assets/custom-carpet/k3009-installed.jpg" }),
      mk("K3080", "Custom Carpet", "/assets/custom-carpet/k3080-tile.jpg", { installed: "/assets/custom-carpet/k3080-installed.jpg" }),
      mk("K3090", "Custom Carpet", "/assets/custom-carpet/k3090-tile.jpg", { installed: "/assets/custom-carpet/k3090-installed.jpg" }),
      mk("K3096", "Custom Carpet", "/assets/custom-carpet/k3096-tile.jpg", { installed: "/assets/custom-carpet/k3096-installed.jpg" }),
      mk("K3097", "Custom Carpet", "/assets/custom-carpet/k3097-tile.jpg", { installed: "/assets/custom-carpet/k3097-installed.jpg" }),
    ],
  },
  "carpet-tiles": {
    slug: "carpet-tiles",
    index: "03",
    name: "Carpet Tiles",
    tagline: "Modular Carpet Tiles",
    banner: IMG.broadloom,
    homeImage: "/assets/home/carpet.png",
    heroSlides: [
      "/assets/carpet-hero/carpet-tiles-hero.jpg",
    ],
    intro:
      "Modular carpet tiles for commercial and residential interiors — hard-wearing, solution-dyed nylon in a considered palette of greys, greens, denim blue and amber.",
    subcategories: [],
    brochure: { url: "/assets/brochures/carpet-tiles.pdf", name: "HOD Carpet Tiles Brochure 2026" },
    products: [
      mk("Light Grey", "", "/assets/carpet/c1.png"),
      mk("Charcoal Black", "", "/assets/carpet/c2.png"),
      mk("Dark Grey", "", "/assets/carpet/c3.png"),
      mk("Stone Grey", "", "/assets/carpet/c4.png"),
      mk("Silver Grey", "", "/assets/carpet/c5.webp"),
      mk("Denim Blue", "", "/assets/carpet/c6.png"),
      mk("Pine Green", "", "/assets/carpet/c7.png"),
      mk("Bamboo Green", "", "/assets/carpet/c8.png"),
      mk("Amber Orange", "", "/assets/carpet/c9.png"),
      mk("Warm Grey", "", "/assets/carpet/c10.png"),
    ],
  },
  "hod-wall-panels": {
    slug: "hod-wall-panels",
    comingSoonPage: true,
    index: "05",
    name: "HOD Wall Panel Collection",
    tagline: "Resilient Ceramic Wall Panels",
    banner: "/assets/wall-panels/hero.jpg",
    homeImage: "/assets/wall-panels/hero.jpg",
    heroSlides: [
      "/assets/wall-panels/hero.jpg",
      "/assets/stone-hero/s1.png",
      "/assets/stone-hero/s3.webp",
    ],
    intro:
      "Resilient ceramic wall panels from House of David — large-format surfaces that reproduce the depth of natural marble, travertine, terrazzo and concrete. Available across our Inspira and Essentials lines.",
    subcategories: ["Inspira", "Essentials"],
    products: [
      mk("Inspira Marble", "Inspira", "/assets/stone-hero/s1.png"),
      mk("Inspira Travertine", "Inspira", "/assets/stone-hero/s2.png"),
      mk("Inspira Terrazzo", "Inspira", "/assets/stone-hero/s3.webp"),
      mk("Inspira Concrete", "Inspira", "/assets/stone-hero/s4.png"),
      mk("Inspira Abstract", "Inspira", "/assets/stone-hero/s5.png"),
      mk("Essentials Marble", "Essentials", "/assets/stone-hero/s1.png"),
      mk("Essentials Travertine", "Essentials", "/assets/stone-hero/s2.png"),
      mk("Essentials Terrazzo", "Essentials", "/assets/stone-hero/s3.webp"),
      mk("Essentials Concrete", "Essentials", "/assets/stone-hero/s4.png"),
    ],
  },
  additional: {
    slug: "additional",
    index: "06",
    name: "Additional Collection",
    tagline: "Micro Cement · Solid Oak Doors",
    banner: IMG.microcement,
    intro:
      "Specialist finishes that complete an interior — seamless micro cement and artisan plastering, with solid oak joinery joining soon.",
    brochure: { url: "/assets/brochures/additional.pdf", name: "Interior Finishes Brochure 2026" },
    subcategories: ["Micro Cement", "Solid Oak Doors"],
    products: [
      mk("Micro Cement Wall Finish", "Micro Cement", IMG.microcement),
      mk("Artisan Plaster Finish", "Micro Cement", IMG.microcement),
      mk("Solid Oak Door", "Solid Oak Doors", IMG.oakDoor, { comingSoon: true }),
    ],
  },
};

COLLECTIONS.timber.products = expand(
  COLLECTIONS.timber.products, 20,
  ["Oak Wall Panel", "Oak Veneer Panel", "Oak Floor Board"],
  COLLECTIONS.timber.subcategories, POOL.wood
);
COLLECTIONS.additional.products = expand(
  COLLECTIONS.additional.products, 8,
  ["Micro Cement Finish", "Artisan Plaster Finish"],
  ["Micro Cement"], [IMG.microcement]
);

export const findProduct = (collectionSlug, productSlug) => {  const collection = COLLECTIONS[collectionSlug];
  if (!collection) return null;
  const product = collection.products.find((p) => p.slug === productSlug);
  return product ? { collection, product } : null;
};

const sec = (heading, body, bullets) => ({ heading, body, bullets });

export const LEGAL = {
  "maintenance-warranty": {
    slug: "maintenance-warranty",
    eyebrow: "Support",
    title: "Maintenance & Warranty",
    intro: "How to care for your House of David materials, and the assurances that come with them.",
    sections: [
      sec(
        "Everyday Care",
        "Natural materials reward a little routine attention. Keep surfaces free of grit and standing water, use protective pads beneath furniture, and address spills promptly. Detailed, material-specific care guidance is supplied with every product and is available to download on each product page."
      ),
      sec(
        "Timber & Veneer",
        "Clean with a dry or barely-damp microfibre cloth. Avoid steam mops, abrasive pads and silicone- or wax-based products. Where a re-oil or re-seal is recommended, follow the finish manufacturer's instructions. Timber is a living material and will shift subtly with humidity — this is normal and not a defect."
      ),
      sec(
        "Natural Stone",
        "Seal as advised for your stone type and clean with a pH-neutral stone cleaner. Avoid acidic products (including vinegar and citrus) and harsh abrasives, which can etch or dull the surface. Reseal periodically to maintain stain resistance, particularly in wet areas."
      ),
      sec(
        "Carpet & Soft Flooring",
        "Vacuum regularly and attend to spills immediately by blotting — never rubbing. Use professional cleaning appropriate to the fibre. Wool and bespoke carpets may show initial shedding, which settles with use."
      ),
      sec(
        "Warranty Coverage",
        "Applicable warranties vary by product and are set out in the documentation supplied with your order. To the extent permitted by law, our liability under any warranty is limited to the repair, replacement or resupply of the affected product, at our discretion.",
        [
          "Warranties do not cover damage from incorrect installation, inadequate maintenance or normal wear.",
          "Use outside a product's intended application may void its warranty.",
          "Correct installation and acclimatisation, where required, are essential to warranty validity.",
        ]
      ),
      sec(
        "Making a Claim",
        "If you believe a product is faulty, please contact us as soon as possible at info@hod.co.nz with your order details and clear photographs of the issue. Our team will assess the claim in line with the relevant product warranty and New Zealand consumer law."
      ),
    ],
  },
  shipping: {
    slug: "shipping",
    eyebrow: "Support",
    title: "Shipping Information",
    intro: "Delivery lead times, our freight process, and logistics across New Zealand.",
    sections: [
      sec(
        "Lead Times",
        "Estimated lead times are a guide only and vary by product, finish and order volume.",
        [
          "Some products are held in stock in New Zealand and dispatch promptly.",
          "Others are produced or imported to order, with longer lead times advised at the time of enquiry.",
          "We will confirm current availability and an estimated delivery window before your order is finalised.",
        ]
      ),
      sec(
        "Delivery & Freight",
        "We arrange freight nationwide through trusted carriers. Delivery costs are calculated by weight, volume and destination, and are confirmed as part of your quote. Risk in the goods passes to you upon delivery or collection."
      ),
      sec(
        "Receiving Your Order",
        "Please inspect your delivery on arrival and note any visible damage on the delivery documentation. Materials should be stored flat, dry and, where relevant, allowed to acclimatise on site prior to installation as set out in the product's installation guide."
      ),
      sec(
        "Made-to-Order Items",
        "Made to order items are scheduled into production once confirmed and paid for, in accordance with our terms of business. Custom and made-to-order products — including custom carpets, rugs, and cut-to-size stone or timber — cannot be cancelled once production has commenced."
      ),
      sec(
        "Delays Beyond Our Control",
        "House of David is not liable for delays caused by circumstances outside our reasonable control, including manufacturing delays, shipping disruptions or supplier availability. We will keep you informed should any such delay arise."
      ),
    ],
  },
  terms: {
    slug: "terms",
    eyebrow: "Legal",
    title: "Terms & Conditions",
    updated: "June 2026",
    intro:
      "These Terms & Conditions govern your use of our website and the purchase of any products or services from House of David. By accessing this website, requesting a consultation, placing an order, or purchasing from us, you agree to be bound by these Terms.",
    sections: [
      sec(
        "1. About Us",
        "House of David supplies high-end timber, natural stone, custom carpet, and interior finishing products, including wall panels, veneers, flooring, and related architectural surfaces. Our products are intended for use by designers, architects, and trade professionals on residential and commercial projects."
      ),
      sec("2. Enquiries, Quotes & Consultations", null, [
        "Product pricing displayed on our website is a guide only and does not constitute a formal quote.",
        "All project pricing is confirmed following an enquiry, consultation, or direct communication with our team.",
        "A consultation does not obligate either party to proceed with an order.",
        "Trade and project pricing is available on request and may differ from retail guide pricing.",
      ]),
      sec("3. Orders & Payment", null, [
        "All orders are subject to product availability and confirmation by House of David.",
        "A deposit or full payment may be required prior to production, allocation of stock, or dispatch, as advised at the time of order.",
        "Prices are quoted in New Zealand dollars (NZD) and exclude GST unless otherwise stated.",
        "We reserve the right to correct pricing errors, including those arising from typographical or system errors, prior to order confirmation.",
      ]),
      sec("4. Lead Times & Delivery", null, [
        "Estimated lead times are provided as a guide and may vary depending on product, finish, order volume, and port of origin. Current guidance is available on our Shipping Information page.",
        "Some products are held in stock in New Zealand; others are produced or imported to order.",
        "Risk in the goods passes to the customer upon delivery or collection.",
        "House of David is not liable for delays caused by circumstances outside our reasonable control, including manufacturing delays, shipping disruptions, or supplier availability.",
      ]),
      sec("5. Product Variation", null, [
        "Timber, natural stone, and other natural materials are subject to natural variation in grain, colour, veining, and texture. Variation between samples, digital imagery, and delivered product should be expected and is not considered a defect.",
        "Product specifications, finishes, and availability may change without notice as our collections evolve.",
      ]),
      sec("6. Installation", null, [
        "Unless explicitly agreed in writing, House of David supplies product only. Installation is carried out by independent, suitably qualified contractors engaged by the customer or their representative.",
        "House of David can provide guidance on suitable installers but is not responsible for the workmanship of any third-party installer.",
        "Correct installation, including any required acclimatisation, preparation, and finishing, is essential to product performance. Failure to follow supplied installation guidance may affect product warranty.",
      ]),
      sec("7. Warranty", null, [
        "Applicable product warranties are outlined on our Maintenance & Warranty page and/or the specific product's documentation.",
        "Warranties do not cover damage resulting from incorrect installation, inadequate maintenance, normal wear, or use outside the product's intended application.",
        "To the extent permitted by law, House of David's liability for any breach of these Terms or any applicable warranty is limited to the repair, replacement, or resupply of the affected product, at our discretion.",
      ]),
      sec("8. Returns & Cancellations", null, [
        "Custom-made, made-to-order, and special-order products (including custom carpets, rugs, and cut-to-size stone or timber) cannot be returned or cancelled once production has commenced.",
        "Stocked products may be eligible for return subject to the product being unused, in its original condition and packaging, and returned within a reasonable timeframe. A restocking fee may apply.",
        "Please contact us before returning any product to confirm eligibility.",
      ]),
      sec(
        "9. Intellectual Property",
        "All content on this website, including images, product designs, layouts, and written material, is the property of House of David and may not be reproduced, distributed, or used without our prior written consent."
      ),
      sec(
        "10. Limitation of Liability",
        "To the maximum extent permitted by law, House of David excludes all liability for any indirect, incidental, or consequential loss arising from the use of our products or website, except where such liability cannot be excluded under applicable consumer law."
      ),
      sec(
        "11. Governing Law",
        "These Terms are governed by the laws of New Zealand, and any disputes will be subject to the exclusive jurisdiction of the New Zealand courts."
      ),
      sec(
        "12. Changes to These Terms",
        "We may update these Terms from time to time. The version published on our website at the time of your order or enquiry will apply."
      ),
      sec(
        "13. Contact Us",
        "For any questions regarding these Terms, please contact us at info@hod.co.nz or 021 430 559."
      ),
    ],
  },
  privacy: {
    slug: "privacy",
    eyebrow: "Legal",
    title: "Privacy Policy",
    updated: "June 2026",
    intro: "How we collect, use and protect your personal information when you interact with House of David.",
    sections: [
      sec(
        "Information We Collect",
        "We collect information you provide directly — such as your name, email, phone number, delivery address and project details — when you enquire, request a consultation, place an order, or contact us. We may also collect basic technical information about how you use our website."
      ),
      sec(
        "How We Use It",
        "We use your information to respond to enquiries, prepare quotes, process and deliver orders, provide aftercare, and improve our products and service. We only use your details for the purposes for which they were provided."
      ),
      sec(
        "Cookies",
        "Our website may use cookies and similar technologies to help the site function and to understand how it is used. You can manage or disable cookies through your browser settings; some features may not work as intended if you do."
      ),
      sec(
        "Sharing & Disclosure",
        "We do not sell your personal information. We may share it with trusted service providers — such as freight carriers and payment processors — strictly as needed to fulfil your order, and with authorities where required by law."
      ),
      sec(
        "Your Rights",
        "Under the New Zealand Privacy Act, you may request access to the personal information we hold about you and ask us to correct it. To make a request, please contact us using the details below."
      ),
      sec(
        "Contact",
        "For any privacy questions or requests, contact us at info@hod.co.nz or 021 430 559."
      ),
    ],
  },
};

const faq = (q, a) => ({ q, a });

export const FAQ = {
  slug: "faqs",
  eyebrow: "Support",
  title: "Frequently Asked Questions",
  intro: "Answers to the questions we're asked most — from samples and lead times to installation and aftercare.",
  groups: [
    {
      group: "About House of David",
      items: [
        faq(
          "What does House of David offer?",
          "House of David supplies high-end timber, natural stone, custom carpet, and interior finishing products for residential and commercial projects. Our collections include timber wall panels, veneers, and flooring; natural stone; custom-made carpets, rugs, and carpet tiles; and additional finishes including micro cement, artisan plastering, and solid oak doors."
        ),
        faq(
          "Who do you work with?",
          "We work with interior designers, architects, and trade professionals."
        ),
        faq(
          "Do you have a showroom?",
          "Yes — under construction."
        ),
      ],
    },
    {
      group: "Products & Collections",
      items: [
        faq(
          "Can I see physical samples before ordering?",
          "Yes, samples can be arranged through a consultation. We recommend viewing samples in your own space where possible, as lighting and surroundings can affect how a finish looks."
        ),
        faq(
          "Will my product look exactly like the photos on the website?",
          "Timber, stone, and other natural materials vary naturally in grain, colour, and texture. Photos and samples are a strong guide, but some variation between images and the finished product should be expected — this is part of what makes natural materials unique."
        ),
        faq(
          "Is the Architectural Stone collection available now?",
          "Our Architectural Stone Collection is ever expanding — most products are made to order, as they are custom made."
        ),
        faq(
          'What does "Coming Soon" mean on a product?',
          "Coming soon means new and exciting products are in the pipeline and will be available shortly."
        ),
      ],
    },
    {
      group: "Ordering & Pricing",
      items: [
        faq(
          "How do I get a price?",
          "Please get in touch."
        ),
        faq(
          "Do you offer trade pricing?",
          "Yes. Trade and project pricing is available for designers, architects, and trade professionals — please contact us at info@hod.co.nz with your project details."
        ),
        faq(
          "What are your lead times?",
          "Our products are made to order. Please get in touch for lead times specific to your product."
        ),
        faq(
          "Can I customise a product?",
          "Our Custom Carpet and Natural Stone Collections can be custom made to suit your project. Speak to our team about what's possible for your space."
        ),
      ],
    },
    {
      group: "Installation",
      items: [
        faq(
          "Do you install the products?",
          "House of David supplies materials; installation is carried out by qualified independent contractors. We're happy to guide you toward suitable installers experienced with our products. See our Services page for more detail."
        ),
        faq(
          "Do I need a professional installer?",
          "Yes, we recommend professional installation for all our products to ensure correct performance and to maintain any applicable warranty. Installation guides are available for download on each product page."
        ),
        faq(
          "Is there anything I need to do before installation?",
          "Some materials require acclimatisation to the site conditions before installation. Specific guidance is provided in each product's installation documentation."
        ),
      ],
    },
    {
      group: "Care & Warranty",
      items: [
        faq(
          "How do I care for my finish?",
          "Each product includes care guidance specific to its material and finish, available for download on the product page. General maintenance advice is also available on our Maintenance & Warranty page."
        ),
        faq(
          "What warranty comes with your products?",
          "Warranty terms vary by product and are outlined on our Maintenance & Warranty page and within individual product documentation."
        ),
        faq(
          "What happens if my product is damaged or faulty?",
          "Please contact us as soon as possible with details and photos of the issue. Our team will assess the situation in line with the applicable product warranty."
        ),
      ],
    },
    {
      group: "Consultations & Getting Started",
      items: [
        faq(
          "How do I start a project with House of David?",
          "The best first step is a project consultation, where our team can understand your space, guide you through relevant collections, and advise on next steps including samples."
        ),
        faq(
          "I'm not sure which product is right for my project — can you help?",
          "Absolutely. Our team regularly advises on material selection for a wide range of spaces and applications. Get in touch and we'll help you find the right fit."
        ),
        faq(
          "How do I contact House of David?",
          "You can reach us via our Contact page, by requesting a project consultation, or by emailing info@hod.co.nz / calling 021 430 559."
        ),
      ],
    },
  ],
};

export const LEGAL_NAV = [
  { label: "Maintenance & Warranty", to: "/maintenance-warranty" },
  { label: "Shipping Information", to: "/shipping" },
  { label: "FAQs", to: "/faqs" },
  { label: "Terms & Conditions", to: "/terms" },
  { label: "Privacy Policy", to: "/privacy" },
];

COLLECTIONS["custom-carpet-range"] = { ...COLLECTIONS["custom-carpet"], slug: "custom-carpet-range", name: "Custom Carpet" };

COLLECTIONS["marble-slabs"] = {
  slug: "marble-slabs",
  index: "04",
  name: "Marble Slabs",
  tagline: "Natural Marble Collection",
  headEyebrow: "Explore Our Natural Marble Collection",
  headTitle: ["Nature creates no", "two pieces the same."],
  heroSlides: [
    "/assets/marble/bathroom-hero.jpg",
    "/assets/marble/m4.jpg",
    "/assets/marble/m9.jpg",
  ],
  heroFit: "cover",
  banner: "/assets/marble/bathroom-hero.jpg",
  homeImage: "/assets/marble/marble-feature-wall.jpg",
  intro:
    "The House of David marble collection celebrates the individuality of natural stone — from subtle veining and soft, understated tones to dramatic movement and striking contrasts. Carefully selected for its character, quality and architectural presence, each slab is a unique composition shaped by nature over time. Designed for kitchens, bathrooms, vanities, feature surfaces and considered interior spaces, our marble brings a sense of permanence and natural beauty to every project. Explore the collection and discover a slab that becomes part of the architecture, not simply a finish.",
  squareGrid: true,
  chooseSlab: {
    eyebrow: "Choose Your Individual Slab",
    title: "The slab you select is the slab that defines your space.",
    paragraphs: [
      "With natural marble, variations in veining, tone, pattern and movement are what make each piece unique. Our team can guide you through the House of David collection, helping you consider the right marble, finish and application for your project.",
      "Once selected, your marble can be reserved for your project and coordinated with your chosen fabricator for cutting, finishing and installation.",
      "Visit House of David to explore the collection and select a piece created by nature, chosen for your space.",
    ],
  },
  subcategories: [],
  products: [
    mk("Marble 01", "", "/assets/marble/m1.jpg", { comingSoonInfo: true }),
    mk("Marble 02", "", "/assets/marble/m2.jpg", { comingSoonInfo: true }),
    mk("Marble 03", "", "/assets/marble/m3.jpg", { comingSoonInfo: true }),
    mk("Marble 04", "", "/assets/marble/m4.jpg", { comingSoonInfo: true }),
    mk("Marble 05", "", "/assets/marble/m5.jpg", { comingSoonInfo: true }),
    mk("Marble 06", "", "/assets/marble/m6.jpg", { comingSoonInfo: true }),
    mk("Marble 07", "", "/assets/marble/m7.jpg", { comingSoonInfo: true }),
    mk("Marble 08", "", "/assets/marble/m8.jpg", { comingSoonInfo: true }),
    mk("Marble 09", "", "/assets/marble/m9.jpg", { comingSoonInfo: true }),
    mk("Marble 10", "", "/assets/marble/m10.jpg", { comingSoonInfo: true }),
    mk("Marble 11", "", "/assets/marble/m11.jpg", { comingSoonInfo: true }),
  ],
};

export const COLLECTION_LIST = [
  COLLECTIONS.timber,
  COLLECTIONS["natural-stone"],
  COLLECTIONS["custom-carpet"],
  COLLECTIONS["marble-slabs"],
];
